import { render, staticRenderFns } from "./pengguna.vue?vue&type=template&id=48e73cb2&"
import script from "./pengguna.vue?vue&type=script&lang=js&"
export * from "./pengguna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports